import {combineReducers} from 'redux';
import AuthReducer from '../Auth/reducer/index'
const appReducer = combineReducers({
  auth: AuthReducer,
});

export default appReducer;
